<template>
  <v-autocomplete
    :items="items"
    v-model="selectedRating"
    :label="label"
    item-text="name"
    item-value="name"
    @change="changeListener"
    :disabled="!enabled"
    :error-messages="errorMessages"
    :outlined="outlined"
    :dense="dense"
    :multiple="multi"
  ></v-autocomplete>
</template>

<script>
import { ALL_STARS_SEARCH_QUERY } from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";

export default {
  name: "StarsListSelect",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    customLabel: { type: String },
    enabled: {
      type: Boolean,
      default: () => true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Array],
      default: () => "",
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    multi: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      starsList: [],
      selectedRating: this.multi
        ? [...this.value]
        : this.value != ""
        ? this.value
        : null,
    };
  },

  methods: {
    changeListener(data) {
      if (typeof data === "string") {
        this.$emit("onSelect", data);
        this.$emit("input", data);
      } else {
        this.$emit("input", [...this.selectedRating]);
      }
    },
  },

  computed: {
    items() {
      return this.stars && this.stars.edges
        ? this.stars.edges.map(removeGQLTypename).filter((item) => {
            return this.value != ""
              ? item.name == this.value || !item.notInUse
              : !item.notInUse;
          })
        : [];
    },
    label() {
      return this.customLabel ? this.customLabel : "Rating";
    },
  },

  watch: {
    value(newVal) {
      this.selectedRating = this.multi
        ? [...newVal]
        : newVal != ""
        ? newVal
        : null;
    },
  },

  apollo: {
    stars: {
      query: ALL_STARS_SEARCH_QUERY,
      variables() {
        return {};
      },
      result({ data, loader, networkStatus }) {
        this.starsList = data.stars.edges.map((star) => ({
          ...star.node,
        }));
      },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/StarsListSelect.vue